import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

interface Props {
  showBackground: boolean;
}

const DialInput = styled.span<Props>`
  background: ${(props) => (props.showBackground ? Colors['dark07'] : '')};
  color: ${Colors['text']};
  display: flex;
  font-family: ${Fonts['regular']};
  font-size: ${80 * Screen.widthRatio}px;
  left: ${124 * Screen.widthRatio}px;
  justify-content: start;
  position: absolute;
  top: ${56 * Screen.widthRatio}px;
  z-index: 2;
`;

export default DialInput;
